module.exports = __webpack_public_path__ + "static/usecase_wallet_right_bg@2x-82bca49a17700875206171bd2e221436.png";